global.stripe = {
		_loaded:false,
		handler:null,
		publicKey:null,
		pay:function(Options) { 
			var options = {
      		    name: 'Operation Tone-Up®',
      		    zipCode: true,
      		    billingAddress:false	
      		};
			
			$.extend(options,Options );
			//console.log(options);
			stripe.handler.open(options);
		},
		isLoaded:function() {
			return stripe._loaded
		},
		loadAsync:function (Options) {
			 console.log('Stripe - Loading Async');

			 var options = {
					 publicKey: 'pk_test_6pRNASCoBOKtIshFeQd4XMUh'
			 };
			 $.extend(options,Options );
			 
			jQuery.ajax({
			    async:false,
			    type:'GET',
			    url:"https://checkout.stripe.com/checkout.js",
			    data:null,
			    success:function() {
			    		stripe.publicKey=options.publicKey;
			    		stripe.handler = StripeCheckout.configure({
			    			key: stripe.publicKey,
			    			image: 'https://knowledgeisland.org/images/OTU_ACT.png',
			    			locale: 'auto'
		        		 }
		        		);
			        	stripe._loaded=true;
			        	
			        	if (typeof options.callback=='function') {
			        		options.callback();
			        	}
			        	

			        },
			    dataType:'script'
			});

			
		}
}